import { endOfMonth, format, min } from 'date-fns';

import { firstDayOf, formatDay, IYearMonth } from '~/utils/date/date';

// Both ends are `yyyy-MM-dd` days.
export interface IEntryDateWindow {
  min: string;
  max: string;
}

export const getEntryDateWindow = (today: Date, selected: IYearMonth): IEntryDateWindow => {
  const monthStart = firstDayOf(selected);
  return {
    min: formatDay(monthStart),
    max: formatDay(min([endOfMonth(monthStart), today])),
  };
};

export const isInEntryDateWindow = (day: string, window: IEntryDateWindow): boolean =>
  day >= window.min && day <= window.max;

export const getOutOfMonthMessage = (selected: IYearMonth): string =>
  `Engagement date must be within ${format(firstDayOf(selected), 'MMMM yyyy')}`;
